module.exports = __webpack_public_path__ + "static/media/tr-copy.bef9e030.png";